export enum ItemModalEnum {
  ADD = "add",
  EDIT = "edit",
}
export const ItemTypes = {
  CARD: "card",
};
export enum DevicePlatform {
  WEB = "WEB",
}
export enum DialogTypes {
  ERROR = "error",
  SUCCESS = "success",
  CONFIRM = "confirm",
  WARNING = "warning",
}
export enum ItemCodeEnum {
  ODOMETER = "ODOMETER",
  SERVICE_METER = "SERVICE_METER",
}
export enum ResultType {
  NUMERIC = "NUMERIC",
  OK_OR_ANOMARY = "OK_OR_ANOMARY",
  ODOMETER = "ODOMETER",
  NONE = "NONE",
  OK_ANOMARY_NOT_APPLICABLE = "OK_ANOMARY_NOT_APPLICABLE",
  FREE_TEXT = "FREE_TEXT",
  PERFORMED = "PERFORMED_OR_NOT_PERFORMED",
}
export enum MaintenanceResultType {
  PERFORMED = "PERFORMED",
  NOT_PERFORMED = "NOT_PERFORMED",
}
export enum MaintenanceWorkType {
  REPLACE = "REPLACE",
  CLEAN_WASH = "CLEAN/WASH",
  REFILL = "REFILL",
}
export enum SelectMachineEnum {
  MACHINE_NAME = "machineName",
}
export enum CurrentStatusPostEnum {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}
export enum ItemResultType {
  OK = "OK",
  ANOMARY = "ANOMARY",
  NONE = "NONE",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  FREE_TEXT = "FREE_TEXT",
  PERFORMED = "PERFORMED",
  NOT_PERFORMED = "NOT_PERFORMED",
}
export enum ItemInspectionEnum {
  STAFF_NAME = "STAFF_NAME",
  LOCATION = "LOCATION",
}
export enum SelectLanguage {
  EN = "en",
  JA = "ja",
  ES = "es",
  PT = "pt",
  AR = "ar",
  UR = "ur",
  TH = "th",
  FR = "fr",
  VI = "vi",
  LO = "lo",
  KM = "km",
  RU = "ru",
}

export const RTL_LANGUAGES: SelectLanguage[] = [
  SelectLanguage.AR,
  SelectLanguage.UR,
];

export const LANGUAGES = [
  { code: SelectLanguage.JA, label: "日本語" },
  { code: SelectLanguage.EN, label: "English" },
  { code: SelectLanguage.ES, label: "Español" },
  { code: SelectLanguage.PT, label: "Português" },
  { code: SelectLanguage.AR, label: "اللغة العربية" },
  { code: SelectLanguage.UR, label: "اردو" },
  { code: SelectLanguage.FR, label: "Français" },
  { code: SelectLanguage.TH, label: "ไทย" },
  { code: SelectLanguage.LO, label: "ລາວ" },
  { code: SelectLanguage.VI, label: "Tiếng Việt" },
  { code: SelectLanguage.KM, label: "ភាសាខ្មែរ" },
  { code: SelectLanguage.RU, label: "Русский" },
];

export enum AnnouncementStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  DELETED = "DELETED",
}

export enum AnnouncementType {
  DOWNTIME = "DOWNTIME",
  UPDATE = "UPDATE",
  FEATURE = "FEATURE",
  OTHER = "OTHER",
}

export enum Platform {
  WEBAPP = "WEBAPP",
  MOBILE_APP = "MOBILE_APP",
}

export enum SupportedLanguageNames {
  en = "English (en)",
  ja = "日本語 (ja)",
  es = "Español (es)",
  pt = "Português (pt)",
  ar = "العربية (ar)",
  ur = "اردو (ur)",
  th = "ไทย (th)",
  fr = "Français (fr)",
  vi = "Tiếng Việt (vi)",
  lo = "ລາວ (lo)",
  km = "ភាសាខ្មែរ (km)",
  ru = "Русский (ru)",
}
export enum ISOLocaleCode {
  EN = "en",
  ES = "es",
  JA = "ja",
  PT = "pt",
  AR = "ar",
  UR = "ur",
  FR = "fr",
  TH = "th",
  VI = "vi",
  LO = "lo",
  KM = "km",
  RU = "ru",
}

export type CountryCode =
  | "BR"
  | "CL"
  | "CO"
  | "EG"
  | "JP"
  | "PH"
  | "SA"
  | "AE"
  | "JO"
  | "TH"
  | "GY"
  | "O";

export const countryCodeOptions: { label: string; value: CountryCode }[] = [
  { label: "Brazil (Brasil)", value: "BR" },
  { label: "Chile", value: "CL" },
  { label: "Colombia", value: "CO" },
  { label: "Egypt (مصر)", value: "EG" },
  { label: "Japan (日本)", value: "JP" },
  { label: "Philippines (Pilipinas)", value: "PH" },
  { label: "Saudi Arabia (المملكة العربية السعودية)", value: "SA" },
  { label: "UAE (الإمارات العربية المتحدة)", value: "AE" },
  { label: "Jordan (الأردن)", value: "JO" },
  { label: "Thailand (ไทย)", value: "TH" },
  { label: "Guyana", value: "GY" },
  { label: "Others", value: "O" },
];
